var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("Multiselect", {
    attrs: {
      "allow-empty": false,
      options: _vm.options,
      value: _vm.selected,
      "open-direction": "bottom",
      "track-by": "freq",
      label: "label"
    },
    on: { select: _vm.select }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }